import Grid from '@mui/material/Grid';
import { Box, Button, Paper, Tab, Tabs, TextField, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import 'dayjs/locale/de';
import AircraftsGrid, { IAircraftsGridRef } from './AircraftsGrid';

function Aircrafts() {
    const [searchText, setSearchText] = useState<string | undefined>(undefined);
    const [filterTerm, setFilterTerm] = useState<string | undefined>(undefined);
    const [showActive, setShowActive] = useState(true);
    const gridRef = useRef<IAircraftsGridRef>(null);


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setFilterTerm(searchText?.toUpperCase()); 
        }, 1000);
    
        return () => clearTimeout(timeoutId);
    }, [searchText]);

    const handleFilterReset = () => {
        setSearchText('');
        setFilterTerm('');
        setShowActive(true);
        gridRef.current?.clearFilter();
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                
                <Paper sx={{ p: 2, paddingBottom: 0, display: 'flex', flexDirection: 'column' }} elevation={3}>
                    <Box sx={{ mb: 1 }}>
                        <Typography variant="subtitle1" component="h2" sx={{ textTransform: 'uppercase' }}>
                            Aircrafts
                        </Typography>
                    </Box>
                    <Tabs value={showActive ? 0 : 1} onChange={(_, value) => setShowActive(value === 0)} variant='scrollable' scrollButtons='auto'>
                        <Tab label='Active' />
                        <Tab label='Inactive' />
                    </Tabs>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Paper sx={{p: 2 }} elevation={3}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField label="Search" variant="outlined" fullWidth size="small" value={searchText} onChange={(e) => setSearchText(e.target.value)}/>
                        <Button variant="contained" onClick={handleFilterReset} >
                            Reset
                        </Button>
                    </Box>
                </Paper>
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: 0, display: 'flex', flexDirection: 'column', minHeight: '100px' }} elevation={3}>
                    <AircraftsGrid ref={gridRef} filterTerm={filterTerm} active={showActive}/>
                </Paper>
            </Grid>
        </Grid>
    );
}

export default Aircrafts;